module.exports = __webpack_public_path__ + "img/nodata.083ceb1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/web/nodata.png
// module id = uBY2
// module chunks = 116 125